export default __webpack_public_path__ + "static/logo_white_trans-219ea91d932d29ac81e1e5e0beb9eab9.png";